import React, { useEffect, useState, useRef, useCallback } from "react";
// 受け取った関数をスロットリング
const useThrottle = (fn, durationMS) => {
  const scrollingTimer = useRef();
  return useCallback(
    (args) => {
      if (scrollingTimer.current) return; // すでにタイマーがセットされている場合は何もしない
      scrollingTimer.current = setTimeout(() => {
        fn(args);
        scrollingTimer.current = undefined; // タイマーをリセット
      }, durationMS);
    },
    [scrollingTimer, fn, durationMS]
  );
}

export default useThrottle;
